import e from "@mui/icons-material/ArrowBack";
import { styled as o, Button as n } from "@mui/material";
import { jsx as t } from "react/jsx-runtime";
const c = o(n)`
  align-items: center;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 2px solid #8f939b;
  display: flex;
  justify-content: center;
  min-width: unset;
  width: 50px;
`, s = o(e)`
  color: #8f939b;
  font-size: 32px;
`, l = (r) => /* @__PURE__ */ t(c, {
  ...r,
  children: /* @__PURE__ */ t(s, {
    className: "Custom-Arrow-Back-Icon"
  })
});
export {
  l as default
};
//# sourceMappingURL=BackButton.js.map
